export const parseQueryString = (qs) =>
  qs.replace('?', '').split('&').reduce((acc, pair) => {
    const [key, value] = pair.split('=');
    return {
      ...acc,
      [key]: decodeURIComponent(value),
    }
  }, {});
